import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi } from '../..';
import {
  type VehiclePreview,
  VehiclePreviewSchema,
} from '../../domain/entities/vehicle';
import { useInjectFeApiContext } from '../../hooks/use-inject-fe-api-context';

export namespace GetAllVehicles {
  export const key = () => ['vehicles', 'get-all-vehicles'];

  export type Params = { refetchInterval?: number; enabled?: boolean };
  export type Output = VehiclePreview[];

  export function useQuery({ refetchInterval, enabled = true }: Params = {}) {
    const getVehicleList = useInjectFeApiContext(
      FeApi.customerInfosV1VehiclesListRetrieve,
    );

    return rq.useQuery<Output>({
      refetchInterval,
      enabled,
      queryKey: key(),
      queryFn: async () => {
        const { vehicles } = await ok(getVehicleList({}));
        return vehicles.map((v) =>
          VehiclePreviewSchema.parse({
            id: v.accure_id,
            fullFrontendId: v.full_frontend_id,
          }),
        );
      },
    });
  }
}
